export const communications = gql`
    mutation communications($input: CommunicationsInput!) {
        communications(
            input: $input
        ) {
            communicationPreferences
        }
    }
`
